import React, { useState, useEffect } from 'react';
import ApiClient from '../../methods/api/apiClient';
import loader from '../../methods/loader';
import { useSelector } from 'react-redux';
import methodModel from '../../methods/methods';
import {
  rolePermission,
  rolePermissions,
  roleType,
} from '../../models/type.model';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Layout from '../../components/global/layout';
import { Tooltip } from 'antd';
import ImageUpload from '../../components/common/ImageUpload';
import SelectDropdown from '../../components/common/SelectDropdown';
import PhoneInput from 'react-phone-input-2';

const AddEditRole = () => {
  const permissions = rolePermissions;
  const permission = rolePermission;
  const [images, setImages] = useState({ image: '' });
  const defaultvalue = () => {
    let keys = { ...roleType };
    Object.keys(roleType).map((itm) => {
      if (itm != 'permissions') keys[itm] = '';
    });
    Object.keys(roleType.permissions).map((itm) => {
      keys.permissions[itm] = false;
    });
    keys.status = 'active';
    return keys;
  };
  const formValidation = [{ key: 'role', required: true }];
  const { id } = useParams();
  const [form, setform] = useState({
    permissions: {
      user_get: false,
      user_delete: false,
      user_edit: false,
      user_add: false,
      user_complete_access: false,
    },
  });
  const history = useNavigate();
  const [submitted, setSubmitted] = useState(false);
  const user = useSelector((state) => state.user);
  console.log(form);
  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    let invalid = methodModel.getFormError(formValidation, form);
    if (invalid) return;
    let method = 'post';
    let url = 'api/role';
    let value = {
      ...form,
      id: id,
    };
    if (id) {
      method = 'put';
      url = 'role';
    } else {
      delete value.id;
    }

    loader(true);
    ApiClient.allApi(url, value, method).then((res) => {
      if (res.success) {
        // ToastsStore.success(res.message);
        history('/roles');
      }
      loader(false);
    });
  };

  useEffect(() => {
    if (id) {
      loader(true);
      ApiClient.get('role', { id }).then((res) => {
        if (res.success) {
          let value = res.data;
          setform({ ...form, role: res?.data?.role, id: `${res?.data?.id}` });
          let payload = roleType;
          let permissions = value.permissions;

          Object.keys(payload).map((itm) => {
            if (itm != 'permissions') payload[itm] = value[itm];
          });

          loader(false);
          Object.keys(roleType.permissions).map((itm) => {
            payload.permissions[itm] = permissions[itm] || false;
          });
          console.log('payload', payload);
          console.log('permissions', permissions);
          payload.id = id;
          setform({
            ...payload,
          });
        }
      });
    } else {
      setform(defaultvalue());
    }
  }, [id]);

  const getError = (key) => {
    return methodModel.getError(key, form, formValidation);
  };

  const isAllChecked = () => {
    let value = true;
    let permissions = {
      user_add: form?.permissions?.user_add,
      user_delete: form?.permissions?.user_delete,
      user_edit: form?.permissions?.user_edit,
      user_get: form?.permissions?.user_get,
    };
    Object.keys(permissions).map((itm) => {
      if (!permissions[itm]) value = false;
    });
    return value;
  };
  console.log(form);
  const HandleAll = (check) => {
    let value = check ? true : false;
    let permissions = {
      user_add: form?.permissions?.user_add,
      user_delete: form?.permissions?.user_delete,
      user_edit: form?.permissions?.user_edit,
      user_get: form?.permissions?.user_get,
      user_complete_access: form?.permissions?.user_complete_access,
    };
    Object?.keys(permissions).map((itm) => {
      permissions[itm] = value;
    });

    setform({ ...form, permissions: permissions });
  };

  const isCheckAll = (key) => {
    let value = true;
    permission.map((itm) => {
      if (!form?.permissions[`${itm.key}${key}`]) value = false;
    });
    return value;
  };
  const handleAdminUser = (check) => {
    let value = check ? true : false;
    setform({
      ...form,
      permissions: {
        ...form.permissions,
        user_get: value,
        user_delete: value,
        user_edit: value,
        user_add: value,
        user_complete_access: value,
      },
    });
    // setpermission('carrier_complete_access',value)
  };

  const setpermission = (key, value) => {
    setform({
      ...form,
      permissions: {
        ...form.permissions,
        [key]: value,
      },
    });
  };

  const isAllPCheck = (key = 'read') => {
    let value = true;
    permissions?.map((itm) => {
      if (!form.permissions[`${key}${itm.key}`]) value = false;
    });
    return value;
  };

  const handleAllPermission = (e) => {
    let key = e.name;
    let checked = e.checked;

    let keys = {};
    permission?.map((itm) => {
      keys = { ...keys, [`${itm.key}_${key}`]: checked };
    });

    setform({
      ...form,
      permissions: {
        ...form?.permissions,
        ...keys,
      },
    });
  };
  const back = () => {
    history(-1);
  };

  const handlecompleteAccess = () => {
    let result = false;
    if (
      form?.permissions?.user_add &&
      form?.permissions?.user_edit &&
      form?.permissions?.user_delete &&
      form?.permissions?.user_get &&
      form?.permissions?.user_complete_access
    ) {
      result = true;
    }
    // setform({...form,permissions:{...form?.permissions,carrier_complete_access:result}})
    return result;
  };
  const arry = [
    1980, 1981, 1982, 1983, 1984, 1985, 1986, 1987, 1988, 1989, 1990, 1991,
    1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999, 2000, 2001, 2002, 2003,
    2004, 2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015,
    2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024,
  ];
  const HandleAllRead = (check) => {
    let value = check ? true : false;
    setform({
      ...form,
      permissions: { ...form.permissions, user_get: value },
    });
    isAllChecked();
  };
  const HandleAllAdd = (check) => {
    let value = check ? true : false;
    setform({
      ...form,
      permissions: { ...form.permissions, user_add: value },
    });
    isAllChecked();
  };
  const HandleallEdit = (check) => {
    let value = check ? true : false;
    setform({
      ...form,
      permissions: { ...form.permissions, user_edit: value },
    });
    isAllChecked();
  };
  const HandleAllDelete = (check) => {
    let value = check ? true : false;
    setform({
      ...form,
      permissions: { ...form.permissions, user_delete: value },
    });
    isAllChecked();
  };
  return (
    <>
      <Layout>
        <form onSubmit={handleSubmit} autoComplete="false" name="addSubAdmin">
          <div className="pprofile1 shadow-lg">
            <div className="flex items-center mb-8">
              <Tooltip placement="top" title="Back">
                <button
                  type="button"
                  onClick={(e) => back()}
                  className="!px-4  py-2 flex items-center justify-center  rounded-lg shadow-btn hover:bg-[#F3F2F5] border  transition-all    mr-3"
                >
                  <i className="fa fa-angle-left text-lg"></i>
                </button>
              </Tooltip>
              <div>
                <h3 className="text-2xl font-semibold text-[#111827]">
                  {form && form.id ? 'Edit' : 'Add'} Roles
                </h3>
                <p class="text-sm font-normal text-[#525252]">
                  Here you can see all about your Roles
                </p>
              </div>
            </div>

            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-6">
                <label>
                  Role Name<span className="star">*</span>
                </label>
                <input
                  type="text"
                  className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                  value={form?.role}
                  onChange={(e) => setform({ ...form, role: e.target.value })}
                />
                {submitted && !form.role ? (
                  <div className="invalid-feedback d-block">
                    Role Name is Required
                  </div>
                ) : (
                  <></>
                )}
              </div>

              {/* {role ? (
                <></>
              ) : (
                <div className="col-span-12 md:col-span-6 ">
                  <label>
                    Role<span className="star">*</span>
                  </label>
                  <SelectDropdown
                    id="statusDropdown"
                    displayValue="name"
                    placeholder="Select Role"
                    intialValue={form.role}
                    country="1"
                    disabled={form.id ? true : false}
                    result={(e) => {
                      setform({ ...form, role: e.value });
                    }}
                    options={roles}
                  />
                  {submitted && !form.role ? (
                    <div className="invalid-feedback d-block">
                      Role is Required
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              )} */}

              {/* <div className="col-span-12 md:col-span-6 ">
                <label>Password</label>
                <div className="inputWrapper">
                  <input
                    type={eyes.password ? 'text' : 'password'}
                    className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                    value={form.password}
                    autoComplete="new-password"
                    onChange={(e) =>
                      setform({ ...form, password: e.target.value })
                    }
                  />
                  <i
                    className={
                      eyes.password
                        ? 'fa fa-eye text-gray-200 text-xs'
                        : 'fa fa-eye-slash text-gray-200 text-xs'
                    }
                    onClick={() =>
                      setEyes({ ...eyes, password: !eyes.password })
                    }
                  ></i>
                </div>
                {submitted && getError('password').invalid ? (
                  <div className="invalid-feedback d-block">
                    Password minimum length should be 8
                  </div>
                ) : (
                  <></>
                )}
              </div>
              <div className="col-span-12 md:col-span-6 ">
                <label>
                  Confirm Password{' '}
                  {form.password ? <span className="star">*</span> : <></>}
                </label>
                <div className="inputWrapper">
                  <input
                    type={eyes.confirmPassword ? 'text' : 'password'}
                    className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                    value={form.confirmPassword}
                    onChange={(e) =>
                      setform({ ...form, confirmPassword: e.target.value })
                    }
                    required={form.password ? true : false}
                  />
                  <i
                    className={
                      eyes.confirmPassword
                        ? 'fa fa-eye text-gray-200 text-xs'
                        : 'fa fa-eye-slash text-gray-200 text-xs'
                    }
                    onClick={() =>
                      setEyes({
                        ...eyes,
                        confirmPassword: !eyes.confirmPassword,
                      })
                    }
                  ></i>
                </div>
                {submitted && getError('confirmPassword').invalid ? (
                  <div className="invalid-feedback d-block">
                    Confirm Password is not matched with Password
                  </div>
                ) : (
                  <></>
                )}
              </div> */}
            </div>
            <div className="col-md-12 mb-3">
              <h5 className="mb-0 mt-4">
                <b>Permissions</b>
              </h5>
              <div class="table-responsive ">
                <div class="table_section tablepadding table-bordered">
                  <table class="table">
                    <thead class="table_head roleTable">
                      <tr class="heading_row">
                        <th scope="col" class="table_data"></th>
                        <th scope="col" class="table_data">
                          <input
                            type="checkbox"
                            onChange={(e) => HandleAll(e.target.checked)}
                            checked={isAllChecked()}
                          />
                          All
                        </th>
                        <th scope="col" class="table_data">
                          <input
                            type="checkbox"
                            onChange={(e) => HandleAllRead(e.target.checked)}
                            checked={form?.permissions?.user_get}
                          />
                          Read
                        </th>
                        <th scope="col" class="table_data">
                          {' '}
                          <input
                            type="checkbox"
                            onChange={(e) => HandleAllAdd(e.target.checked)}
                            checked={form?.permissions?.user_add}
                          />
                          Add
                        </th>
                        <th scope="col" class="table_data">
                          {' '}
                          <input
                            type="checkbox"
                            onChange={(e) => HandleallEdit(e.target.checked)}
                            checked={form?.permissions?.user_edit}
                          />
                          Edit
                        </th>
                        <th scope="col" class="table_data">
                          {' '}
                          <input
                            type="checkbox"
                            onChange={(e) => HandleAllDelete(e.target.checked)}
                            checked={form?.permissions?.user_delete}
                          />
                          Delete
                        </th>
                        {/* <th scope="col" class="table_data"> <input
                            type="checkbox"  onChange={e=>HandleRefreshAll(e.target.checked)} checked={form.permissions.refreshBooking}/>Refresh</th> */}
                      </tr>
                    </thead>
                    <tbody className="roleTable">
                      <tr>
                        <td>
                          <b>Users</b>
                        </td>
                        <td>
                          <input
                            type="checkbox"
                            onChange={(e) => {
                              handleAdminUser(e.target.checked);
                              //   if(e.target?.checked){
                              //     setform({...form,permissions:{...form?.permissions,carrier_complete_access:true}})
                              //   }else
                            }}
                            checked={handlecompleteAccess()}
                          />
                        </td>
                        <td>
                          <input
                            type="checkbox"
                            checked={form?.permissions?.user_get}
                            onChange={(e) =>
                              setpermission('user_get', e.target.checked)
                            }
                          />
                        </td>
                        <td>
                          <input
                            type="checkbox"
                            checked={form?.permissions?.user_add}
                            onChange={(e) =>
                              setpermission('user_add', e.target.checked)
                            }
                          />{' '}
                        </td>
                        <td>
                          <input
                            type="checkbox"
                            checked={form?.permissions?.user_edit}
                            onChange={(e) =>
                              setpermission('user_edit', e.target.checked)
                            }
                          />{' '}
                        </td>
                        <td>
                          <input
                            type="checkbox"
                            checked={form?.permissions?.user_delete}
                            onChange={(e) =>
                              setpermission('user_delete', e.target.checked)
                            }
                          />{' '}
                        </td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="flex justify-end mt-6">
              <button
                type="submit"
                className="text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:opacity-80 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
              >
                Save
              </button>
            </div>
          </div>
        </form>
      </Layout>
    </>
  );
};

export default AddEditRole;
